import { render, staticRenderFns } from "./Recordatorios.vue?vue&type=template&id=46247afe"
import script from "./Recordatorios.vue?vue&type=script&lang=js"
export * from "./Recordatorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports